// Brand imagery for Sister Diamonds platform
// Images showcasing professional Black women ages 35-65 in various contexts:
// - Restful power, sisterhood moments, sacred rituals, bold leadership, wellness

export const BRAND_IMAGES = {
  // Hero and Landing Page Images
  hero: {
    main: 'https://images.unsplash.com/photo-1707995673778-f7ded37a4c17?w=1200&q=80',
    description: 'Professional Black woman in white suit - confident and powerful'
  },
  
  // User-provided Sister Diamonds group images
  sisterDiamonds: {
    joyfulSister: 'https://customer-assets.emergentagent.com/job_serene-edison/artifacts/yd1dcs91_6.png',
    porchGroup: 'https://customer-assets.emergentagent.com/job_serene-edison/artifacts/bslsqliy_7.png',
    streetGroup: 'https://customer-assets.emergentagent.com/job_serene-edison/artifacts/btantxd6_8.png',
    beachGroup: 'https://customer-assets.emergentagent.com/job_serene-edison/artifacts/gbxxm43k_10.png',
    journalBanner: 'https://customer-assets.emergentagent.com/job_serene-edison/artifacts/3j8aeigi_9.png'
  },
  
  // Sisterhood & Community Images - Group photos of Black women
  sisterhood: {
    // Group of mature Black women friends in colorful clothing - perfect for Inner Circle
    // National Mall DC - professional women laughing together in green/yellow dresses
    communityJoy: 'https://images.unsplash.com/photo-1630726410985-a1021e8a232a?w=1200&q=80',
    // Happy women from Ghana - joyful Black women in white, sisterhood celebration
    ghanaJoy: 'https://images.unsplash.com/photo-1658092967527-4e140d9bdaea?w=1200&q=80',
    // Women sitting together in connection
    gathering: 'https://images.unsplash.com/photo-1633608689013-3bec6956b2cf?w=800&q=80',
    // Women empowerment group
    empowerment: 'https://images.unsplash.com/photo-1707409066859-a90674383d19?w=800&q=80',
    laughing: 'https://images.unsplash.com/photo-1739302750675-042ed497a429?w=800&q=80',
    connection: 'https://images.unsplash.com/photo-1543366749-4dad497ea0a0?w=800&q=80',
    // African American women friends laughing - warmth and friendship
    friendsLaughing: 'https://images.pexels.com/photos/5047002/pexels-photo-5047002.jpeg?w=800',
    // Women hugging - sisterly bond
    sisterhoodHug: 'https://images.pexels.com/photos/5050135/pexels-photo-5050135.jpeg?w=800'
  },
  
  // Inner Edge specific imagery
  innerEdge: {
    // Professional Black women in business meeting - leadership and growth
    communityBanner: 'https://images.unsplash.com/photo-1573165706511-3ffde6ef1fe3?w=1200&h=300&fit=crop',
    // Five people at conference table
    leadership: 'https://images.unsplash.com/photo-1573497701240-345a300b8d36?w=800&q=80'
  },
  
  // Rest & Wellness Images - Black women in wellness settings
  wellness: {
    spa: 'https://images.unsplash.com/photo-1630595271375-5073a6c0638b?w=800&q=80',
    reading: 'https://images.unsplash.com/photo-1655402428298-fe9b5fb757df?w=800&q=80',
    joyful: 'https://images.unsplash.com/photo-1542278881-48c06d8c8286?w=800&q=80',
    peaceful: 'https://images.unsplash.com/photo-1627130595904-ebeeb6540a93?w=800&q=80',
    smiling: 'https://images.unsplash.com/photo-1694299352873-0c29d862e87a?w=800&q=80'
  },
  
  // Journaling & Reflection Images
  reflection: {
    journaling: 'https://images.unsplash.com/photo-1516182823370-7a5fa91445c3?w=800&q=80',
    writing: 'https://images.unsplash.com/photo-1740663173325-c3000e33c830?w=800&q=80',
    reading: 'https://images.unsplash.com/photo-1655402428298-fe9b5fb757df?w=800&q=80'
  },
  
  // Professional & Leadership Images
  leadership: {
    confident: 'https://images.unsplash.com/photo-1508002366005-75a695ee2d17?w=800&q=80',
    executive: 'https://images.unsplash.com/photo-1762341124796-530c0085f7d8?w=800&q=80',
    speaking: 'https://images.unsplash.com/photo-1707995673778-f7ded37a4c17?w=800&q=80'
  },
  
  // Portrait & Profile Images  
  portraits: {
    smile1: 'https://images.unsplash.com/photo-1508002366005-75a695ee2d17?w=400&q=80',
    smile2: 'https://images.unsplash.com/photo-1694299352873-0c29d862e87a?w=400&q=80',
    smile3: 'https://images.unsplash.com/photo-1542278881-48c06d8c8286?w=400&q=80'
  },
  
  // Testimonial Avatars
  testimonials: [
    {
      url: 'https://images.unsplash.com/photo-1508002366005-75a695ee2d17?w=100&q=80',
      name: 'Sister Diamond Member'
    },
    {
      url: 'https://images.unsplash.com/photo-1694299352873-0c29d862e87a?w=100&q=80',
      name: 'Sister Diamond Member'
    },
    {
      url: 'https://images.unsplash.com/photo-1542278881-48c06d8c8286?w=100&q=80',
      name: 'Sister Diamond Member'
    }
  ]
};

export default BRAND_IMAGES;
